<div class="container" *ngIf="guiService.userLogged">
  <h2>{{"PROFILE.NUTRITION.TITLE" | translate}}</h2>

  <span class="nutrition-guide-container">
    <div *ngIf="translate.currentLang === 'it'" class="guides">
      <img src="../../../assets/img/lineaGuida_Alimentazione.png" alt="" (click)="presentModalPdf(2)">
      <img src="../../../assets/img/lineaGuida_InCucina.png" alt="" (click)="presentModalPdf(1)">
    </div>
    <div *ngIf="translate.currentLang === 'en'" class="guides">
      <img src="../../../assets/img/lineaGuida_Alimentazione_en.png" alt="" (click)="presentModalPdf(2)">
      <img src="../../../assets/img/lineaGuida_InCucina_en.png" alt="" (click)="presentModalPdf(1)">
    </div>
  </span>

  <div *ngIf="guiService.userLogged.userPaymentInfo.subscriptionType === 'GOLD'" class="gold-box">
    <button class="its-button" (click)="discover()">{{"PROFILE.NUTRITION.DISCOVER" | translate}}</button>
    <div class="info-div">
      <span (click)="infos()"><mat-icon>info</mat-icon>{{"PROFILE.NUTRITION.INFO" | translate}}</span>
    </div>
  </div>

  <div class="survey-box" *ngIf="guiService.userLogged.userPaymentInfo.subscriptionType === 'DIAMOND'">
    <div class="infos">
      <h3>{{"PROFILE.NUTRITION.QUESTIONNAIRE" | translate}}</h3>
      <p *ngIf="guiService.userLogged.masterData.lastSurvey">{{"PROFILE.NUTRITION.COMPILED-ON" | translate}} {{guiService.userLogged.masterData.lastSurvey | date: guiService.dateFormat}}</p>
    </div>
    <div class="more-infos">
      <span class="time-badge">
        <mat-icon svgIcon="mat:schedule"></mat-icon>
        <span *ngIf="calcNextQuestionnaire() < 1 || !guiService.userLogged.masterData.lastSurvey">{{"PROFILE.NUTRITION.COMPILE_QUESTIONNAIRE" | translate}}</span>
        <span *ngIf="calcNextQuestionnaire() > 0 && guiService.userLogged.masterData.lastSurvey">{{calcNextQuestionnaire()}} {{"PROFILE.NUTRITION.NEXT_QUESTIONNAIRE" | translate}}</span>
      </span>
      <span class="arrow-badge" *ngIf="calcNextQuestionnaire() < 1 || !guiService.userLogged.masterData.lastSurvey" (click)="compileSurvey()">
        <mat-icon svgIcon="mat:arrow_forward"></mat-icon>
      </span>
    </div>
  </div>
  <div class="meal-box" *ngIf="guiService.userLogged.userPaymentInfo.subscriptionType === 'DIAMOND'">
    <div class="infos">
      <h3>{{"PROFILE.NUTRITION.MEAL-PLAN" | translate}}</h3>
      <p *ngIf="guiService.userLogged.masterData.lastDietUploaded">{{"PROFILE.NUTRITION.LAST-DIET-RECEIVED" | translate}} {{guiService.userLogged.masterData.lastDietUploaded | date: guiService.dateFormat}}</p>
    </div>
    <div class="more-infos">
      <span class="time-badge">
        <mat-icon svgIcon="mat:schedule"></mat-icon>
        <span *ngIf="guiService.userLogged.masterData?.lastSurveyWithDietUploadedId !== guiService.userLogged.masterData?.lastSurveyId">{{"PROFILE.NUTRITION.DIET-INCOMING" | translate}}</span>
        <span *ngIf="guiService.userLogged.masterData?.lastSurveyWithDietUploadedId === guiService.userLogged.masterData?.lastSurveyId && guiService.userLogged.masterData.lastSurvey">{{"PROFILE.NUTRITION.DIET-DELIVERED" | translate}}</span>
      </span>
      <span class="arrow-badge" *ngIf="guiService.userLogged.masterData.lastSurvey && guiService.userLogged.masterData.lastSurveyWithDietUploadedId" (click)="getDiet()">
        <mat-icon svgIcon="mat:arrow_forward"></mat-icon>
      </span>
    </div>
  </div>
  <div class="info-div" *ngIf="guiService.userLogged.userPaymentInfo.subscriptionType === 'DIAMOND'">
    <span (click)="infos()"><mat-icon>info</mat-icon>{{"PROFILE.NUTRITION.INFO" | translate}}</span>
  </div>
</div>
